import React, { useState } from 'react';

function HandwritingPreview({ memo, onEdit, onDelete, theme = 'dark' }) {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const styles = {
    container: {
      backgroundColor: theme === 'dark' ? '#161b22' : '#ffffff',
      border: `1px solid ${theme === 'dark' ? '#30363d' : '#d0d7de'}`,
      borderRadius: '8px',
      overflow: 'hidden',
      marginBottom: '16px',
      transition: 'all 0.3s ease',
    },
    header: {
      padding: '12px 16px',
      backgroundColor: theme === 'dark' ? '#0d1117' : '#f6f8fa',
      borderBottom: `1px solid ${theme === 'dark' ? '#21262d' : '#d0d7de'}`,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      cursor: 'pointer',
    },
    title: {
      fontSize: '16px',
      fontWeight: '600',
      color: theme === 'dark' ? '#e6edf3' : '#24292f',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    previewContainer: {
      padding: '16px',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: theme === 'dark' ? '#0d1117' : '#ffffff',
    },
    previewImage: {
      maxWidth: '100%',
      maxHeight: isExpanded ? '500px' : '200px',
      borderRadius: '4px',
      cursor: 'zoom-in',
      transition: 'all 0.3s ease',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    },
    expandedImage: {
      maxWidth: '90vw',
      maxHeight: '80vh',
      cursor: 'zoom-out',
    },
    actions: {
      display: 'flex',
      gap: '8px',
      alignItems: 'center',
    },
    badge: {
      backgroundColor: '#6f42c120',
      color: '#6f42c1',
      fontSize: '12px',
      padding: '3px 8px',
      borderRadius: '12px',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
    },
    loadingContainer: {
      padding: '40px',
      textAlign: 'center',
      color: theme === 'dark' ? '#8b949e' : '#6e7781',
    },
  };
  
  const handleImageClick = (e) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };
  
  const handleEditClick = (e) => {
    e.stopPropagation();
    if (onEdit) onEdit();
  };
  
  const handleDeleteClick = (e) => {
    e.stopPropagation();
    if (onDelete) onDelete();
  };
  
  // 如果没有手写数据，显示提示
  if (!memo.handwriting_data) {
    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <div style={styles.title}>
            <span>✍️</span>
            {memo.title || '手写备忘录'}
            <span style={styles.badge}>
              <span>手写内容（数据缺失）</span>
            </span>
          </div>
          
          <div style={styles.actions}>
            <button
              onClick={handleEditClick}
              className="btn btn-secondary"
              style={{ padding: '4px 8px', fontSize: '12px' }}
            >
              重新编辑
            </button>
            <button
              onClick={handleDeleteClick}
              className="btn btn-danger"
              style={{ padding: '4px 8px', fontSize: '12px' }}
            >
              删除
            </button>
          </div>
        </div>
        
        <div style={styles.loadingContainer}>
          <p>手写内容数据缺失或损坏</p>
          <button 
            onClick={handleEditClick}
            className="btn btn-primary"
            style={{ marginTop: '10px' }}
          >
            重新编辑
          </button>
        </div>
      </div>
    );
  }
  
  return (
    <div style={styles.container}>
      <div style={styles.header} onClick={() => setIsExpanded(!isExpanded)}>
        <div style={styles.title}>
          <span>✍️</span>
          {memo.title || '手写备忘录'}
          <span style={styles.badge}>
            <span>手写内容</span>
          </span>
        </div>
        
        <div style={styles.actions}>
          <button
            onClick={handleEditClick}
            className="btn btn-secondary"
            style={{ padding: '4px 8px', fontSize: '12px' }}
          >
            编辑
          </button>
          <button
            onClick={handleDeleteClick}
            className="btn btn-danger"
            style={{ padding: '4px 8px', fontSize: '12px' }}
          >
            删除
          </button>
          <span style={{ fontSize: '12px', color: theme === 'dark' ? '#8b949e' : '#6e7781' }}>
            {isExpanded ? '点击收起' : '点击展开'}
          </span>
        </div>
      </div>
      
      <div style={styles.previewContainer}>
        <img
          src={memo.handwriting_data}
          alt="手写内容"
          style={{
            ...styles.previewImage,
            ...(isExpanded && styles.expandedImage)
          }}
          onClick={handleImageClick}
          onError={(e) => {
            console.error('手写图片加载失败:', memo.id);
            e.target.style.display = 'none';
            // 可以在这里显示一个占位符
          }}
        />
      </div>
    </div>
  );
}

export default HandwritingPreview;